export default "__VITE_ASSET__b93dcfdc__"